import { type PropsWithChildren } from 'react';

import { SizedBox } from '@eneco/custom-components/CircledNumber';
import { Stack, Stretch, Text } from '@eneco/sparky';
import { type BoxProps, type FeedbackColors } from '@eneco/sparky/types';

interface Props extends PropsWithChildren {
  backgroundColor?:
    | Extract<BoxProps['backgroundColor'], 'backgroundDark'>
    | Extract<keyof FeedbackColors, 'feedbackSuccess' | 'feedbackWarning' | 'feedbackError'>;
}

export const CircledNumber = ({ backgroundColor, children }: Props) => (
  <SizedBox borderRadius="round" backgroundColor={backgroundColor || 'backgroundDark'}>
    <Stretch>
      <Stack alignY="center">
        <Text size="BodyXL" weight="bold" color="textInverted" align="center">
          {children}
        </Text>
      </Stack>
    </Stretch>
  </SizedBox>
);
